import { render, staticRenderFns } from "./ProjectDetailsPage.vue?vue&type=template&id=20618862"
import script from "./ProjectDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports